module.exports = __webpack_public_path__ + "assets/dashboard-inactive.5e8da3bd.svg";